import { isNil } from 'ramda';
import { Theme, SystemSize } from '~/theme';

/**
 * Transforms given values into a string format that css expects
 * @param {Array<SystemSize | null>} array
 * keywords: css array, margin, padding
 */
const arrayToCss = (array: Array<SystemSize | null>, theme: Theme): string =>
  array.reduce(
    (acc, item) => acc + ` ${!isNil(item) ? theme.space(item) : '0'}`,
    '',
  );

export default arrayToCss;
